import { Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";
import { CustomSectionService } from "@/shared/components/custom-section/custom-section.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'cosmos-custom-section',
  templateUrl: './custom-section.component.html',
  styleUrls: ['./custom-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CustomSectionService],
})
export class CustomSectionComponent implements OnDestroy {
  @Input() public title: string;
  @Input() public loading: boolean;

  private readonly _subscription: Subscription = new Subscription();

  public constructor(
    private readonly _customSectionService: CustomSectionService,
  ) {
    this._subscription.add(
      this._customSectionService
        .loading$.subscribe(next => this.loading = next),
    );
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
